export default "__VITE_ASSET__CVZFE4b6__"